var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"border rounded bg-white status-badge",class:[
      ("text-" + _vm.statusVariant),
      ("border-" + _vm.statusVariant),
      _vm.statusInfo.title === 'PACKED' && !_vm.disabled ? 'yellow-badge' : ''
    ]},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.statusInfo.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }